import React from "react";
import { Redirect } from "react-router-dom";

class ProtectedRoute extends React.Component {
  render() {
    const Component = this.props.component;
    const isAuthenticated =
      localStorage.getItem("token") === null ? false : true;

    return isAuthenticated ? (
      <Component />
    ) : (
      window.open("/","_self")
    );
  }
}

export default ProtectedRoute;
